import {
    HIDE_NOTIFICATION,
    SHOW_NOTIFICATION,
} from 'store/actions/types';

const initialState = {
    text: '',
    type: 'info', // 'info', 'confirm', 'warning'
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case HIDE_NOTIFICATION:
            return Object.assign({}, state, {
                text: '',
            });
        case SHOW_NOTIFICATION:
            return {
                text: payload.text,
                type: payload.type,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/store/reducers/notificationReducer.js